export const PWA_VERSION = '1.3.16';
